import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import style from './save-filterview-modal.module.less';

export const Error = ({ message }) => {
  return (
    <div className={style['error-wrapper']}>
      <div className={style.error}>
        <FontAwesomeIcon icon={faExclamationCircle} />
        <div className={style['error-message']}>
          <FormattedMessage defaultMessage='Error' description='saveFilterViewModal.error' id='bbcy40' />
        </div>
      </div>
      <div className={style['error-details']}>{message}</div>
    </div>
  );
};

Error.propTypes = {
  message: PropTypes.string.isRequired,
};
